import { Input, Space, Typography, Form } from 'antd';

const ChangePassword = ( props ) => {
  const { Text } = Typography;
  const { setPasswordData, isEditing } = props;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPasswordData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <div>
      <Form
      name="passwordChangeForm"
      layout="vertical"
    >
      <Space direction="vertical" style={{ width: '100%' }}>
        <div style={{ marginBottom: '1rem' }}>
          <Text>Password must be:</Text>
          <ul>
            <li>A minimum of 8 characters</li>
            <li>At least one lowercase letter (a-z)</li>
            <li>At least one uppercase letter (A-Z)</li>
            <li>At least one number (0-9)</li>
          </ul>
        </div>
        <Form.Item
          name="currentPwd"
          label="Current Password"
          rules={[{ required: true, message: 'Please input your current password!' }]}
        >
          <Input.Password style={{ width: '20rem' }} placeholder="Enter current password" 
                name="currentPwd"
                onChange={handleChange}
                disabled={!isEditing}/>
          </Form.Item>

        <Form.Item
          name="pwd"
          label="New Password"
          rules={[
            { required: true, message: 'Please input your new password!' },
            { min: 8, message: 'Password must be at least 8 characters!' },
            { pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/, message: 'Password must contain at least one lowercase letter, one uppercase letter, and one number!' }
          ]}
        >
          <Input.Password style={{ width: '20rem' }} placeholder="Enter new password" 
                name="pwd"
                onChange={handleChange}
                disabled={!isEditing}/>
        </Form.Item>

        <Form.Item
          name="confirmPwd"
          label="Confirm Password"
          dependencies={["pwd"]}
          rules={[
            { required: true, message: 'Please confirm your new password!' },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("pwd") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error("Password doesn't match."));
              },
            }),
          ]}
        >
          <Input.Password style={{ width: '20rem' }} placeholder="Confirm new password" 
                name="confirmPwd"
                onChange={handleChange}
                disabled={!isEditing}/>
        </Form.Item>
      </Space>
    </Form>
    </div>
  )
}

export default ChangePassword